import { render, staticRenderFns } from "./PageViewsTable.vue?vue&type=template&id=7668188a&scoped=true"
import script from "./PageViewsTable.vue?vue&type=script&lang=js"
export * from "./PageViewsTable.vue?vue&type=script&lang=js"
import style0 from "./PageViewsTable.vue?vue&type=style&index=0&id=7668188a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7668188a",
  null
  
)

export default component.exports